import { useEffect, useState, useCallback } from "react";
import { AnimatePresence, motion } from "framer-motion";
import IdleScreen from "./idleScreen";
import PinAuthentication from "./pinAuthentication";
import KioskOrder from "./kioskOrder";
import KioskOrderReview from "./kioskOrderReview";
import ClientService from "../../rest/clientService";
import { useCashFlowUpdates } from "../../ws/useCashFlowUpdates";
import { useAdminPreferencesUpdates } from "../../ws/useAdminPreferencesUpdates";

function Kiosk() {
  const [screen, setScreen] = useState("idle");
  const [user, setUser] = useState(null);
  const [cart, setCart] = useState({});
  const [clientPreferences, setClientPreferences] = useState(null);
  const clientCode = sessionStorage.getItem('clientCode');

  const loadPreferences = useCallback(async () => {
    try {
      const clientData = await ClientService.getClientAdminPreferences();
      setClientPreferences(clientData);
    } catch (error) {
      console.error("Erro ao buscar preferências do cliente:", error);
    }
  }, []);

  useEffect(() => { loadPreferences(); }, [loadPreferences]);

  useAdminPreferencesUpdates({ fetchPreferences: loadPreferences, clientCode });

  const handleCashFlowClosed = useCallback(() => {
    setCart({});
    setUser(null);
    setScreen("idle");
  }, []);

  useCashFlowUpdates({ clientCode, onClosed: handleCashFlowClosed });

  const handleStart = () => {
    if (clientPreferences?.allow_anonymous_orders_kiosk) {
      setUser({
        login: "anonymous",
        name: "",
        type: "anonymous",
      });
      setCart({});
      setScreen("order");
    } else {
      setScreen("pinLogin");
    }
  };

  return (
    <div className="h-screen w-screen relative overflow-hidden">
      <AnimatePresence mode="wait">
        {screen === "idle" && (
          <motion.div
            key="idle"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.5 }}
          >
            <IdleScreen onStart={handleStart} />
          </motion.div>
        )}

        {screen === "pinLogin" && (
          <motion.div
            key="pinLogin"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.5 }}
          >
            <PinAuthentication
              onCancel={() => setScreen("idle")}
              onSuccess={(authenticatedUser) => {
                setUser(authenticatedUser);
                setCart({});
                setScreen("order");
              }}
            />
          </motion.div>
        )}

        {screen === "order" && (
          <motion.div
            key="order"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.5 }}
          >
            <KioskOrder
              cart={cart}
              setCart={setCart}
              onBack={() =>
                clientPreferences?.allow_anonymous_orders_kiosk
                  ? setScreen("idle")
                  : setScreen("pinLogin")
              }
              onReview={() => setScreen("review")}
            />
          </motion.div>
        )}

        {screen === "review" && (
          <motion.div
            key="review"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.5 }}
          >
            <KioskOrderReview
              cart={cart}
              user={user}
              onBack={() => setScreen("order")}
              onFinish={() => {
                setCart({});
                setUser(null);
                setScreen("idle");
              }}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default Kiosk;
